/**
 * @description Merchant-facing copy for recurring charge_log errors.
 * SoT is the log row: error_code (class) + error_message (detail).
 * Maps codes whose stored message leaks ids; CHARGE_FAILED is a catch-all
 * so the stripped error_message is shown (never a generic substitute).
 * @dependencies none
 * @notes Display only. Does not invent codes or rewrite the log.
 */

const UUID_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/gi;

const BY_CODE = {
  CARD_INACTIVE: 'Card is inactive. Attach a live card on Edit Plan.',
  STORED_CARD_NOT_FOUND: 'Card is no longer on file. Add a card on the customer, then attach it on Edit Plan.',
  CARD_EXPIRED: 'Card has expired. Update the payment method on Edit Plan.',
  SURCHARGE_CHECK_FAILED: 'Couldn’t verify the processing fee. Check payment settings and try again.'
};

const GENERIC_FAILED = 'Charge didn’t go through.';

/**
 * @param {string} text
 * @returns {string}
 */
function stripIds(text) {
  return String(text)
    .replace(UUID_RE, '')
    .replace(/\s{2,}/g, ' ')
    .replace(/^[:\s,-]+|[:\s,-]+$/g, '')
    .trim();
}

/**
 * @param {{ error_code?: string, errorCode?: string, error_message?: string, errorMessage?: string }|null|undefined} charge
 * @returns {string}
 */
export default function formatChargeHistoryError(charge) {
  if (!charge) return '';
  const code = charge.error_code || charge.errorCode;
  const raw = charge.error_message || charge.errorMessage || '';

  if (code && BY_CODE[code]) return BY_CODE[code];

  if (!raw) return code === 'CHARGE_FAILED' ? GENERIC_FAILED : '';
  if (/inactive for company/i.test(raw)) return BY_CODE.CARD_INACTIVE;
  if (/not found for company/i.test(raw)) return BY_CODE.STORED_CARD_NOT_FOUND;
  if (/surcharge check failed/i.test(raw)) return BY_CODE.SURCHARGE_CHECK_FAILED;
  if (/has expired/i.test(raw)) return BY_CODE.CARD_EXPIRED;

  return stripIds(raw) || GENERIC_FAILED;
}
